import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import Footer from "../Components/common/footer";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
import ReportingControlsHeader from "../Components/FirmReporting/reporting-controls";
import FirmReportingIntake from "../Components/FirmReporting/tabs/firm-reporting-intake";
import CaseMgmtHeader from "../Components/FirmReporting/case-mgmt-tab/case-mgmt-header";
import LitigationHeader from "../Components/FirmReporting/litigation-tab/litigation-header";
import SettlementHeader from "../Components/FirmReporting/settlement-tab/settlement-header";
import FirmTabHeader from "../Components/FirmReporting/firm-tab/firm-tab-header";

const FirmReportingPage = () => {
  const [currentPage, setCurrentPage] = useState("intake");
  const dispatch = useDispatch();
  const currentCaseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 78).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  useEffect(() => {
    fetchShakespeareStatus(currentCaseId, 78, dispatch);
  }, [currentCaseId, dispatch]);
  //
  const mainTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "intake",
      label: "Intake",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("intake"),
      leftHand: false,
    });

    tabs.push({
      id: "case-mgmt",
      label: "Case Management",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("case-mgmt"),
      leftHand: false,
    });

    tabs.push({
      id: "settlement",
      label: "Settlement",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("settlement"),
      leftHand: false,
    });
    tabs.push({
      id: "litigation",
      label: "Litigation",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("litigation"),
      leftHand: false,
    });
    tabs.push({
      id: "firm",
      label: "Firm",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("firm"),
      leftHand: false,
    });

    return tabs;
  }, [handlePageChange]);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const [template, setTemplate] = useState(null);
  const controlRef = useRef(null);
  const mainRef2 = useRef(null);
  const [reportData, setReportData] = useState([]);
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="78" />
          <ActionBarComponent
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div ref={mainRef2} className="TreatmentPage-main-container invisible-scrollbar">
            {currentPage === "intake" && (
              <div ref={controlRef}>
                <ReportingControlsHeader
                  currentPage={currentPage}
                  reportData={reportData}
                  setTemplateId={setTemplate}
                  templateActive={template}
                  mainTabs={mainTabs}
                />
              </div>
            )}

            {currentPage === "case-mgmt" && (
              <>
                <CaseMgmtHeader mainRef2={mainRef2} currentPage={currentPage} mainTabs={mainTabs} />
              </>
            )}
            {currentPage === "litigation" && (
              <>
                <LitigationHeader
                  mainRef2={mainRef2}
                  currentPage={currentPage}
                  mainTabs={mainTabs}
                />
              </>
            )}
            {currentPage === "settlement" && (
              <>
                <SettlementHeader
                  mainRef2={mainRef2}
                  currentPage={currentPage}
                  mainTabs={mainTabs}
                />
              </>
            )}
            {currentPage === "firm" && (
              <>
                <FirmTabHeader mainRef2={mainRef2} currentPage={currentPage} mainTabs={mainTabs} />
              </>
            )}
            {currentPage === "intake" && (
              <>
                <FirmReportingIntake
                  mainRef={mainRef2}
                  controlRef={controlRef}
                  template={template}
                  setReportData={setReportData}
                />
              </>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default React.memo(FirmReportingPage);
